import React from 'react';
// import {
//   useReactTable,
//   getCoreRowModel,
//   flexRender,
// } from '@tanstack/react-table';

const CommonReactTable = ({ columns, data = [], loading = false, emptyText = "No data" }) => {
  // const table = useReactTable({
  //   data,
  //   columns,
  //   getCoreRowModel: getCoreRowModel(),
  // });

  return (
    <div className="_tab_htLane">
      <div className="anv_fr_detailHead">
        {/* <table className="_trpTable_xd">
          <thead className="table_head_style">
            {table.getHeaderGroups().map(headerGroup => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map(header => (
                  <th key={header.id}>
                    {flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns.length}>Loading...</td>
              </tr>
            ) : table.getRowModel().rows.length > 0 ? (
              table.getRowModel().rows.map(row => (
                <tr key={row.id}>
                  {row.getVisibleCells().map(cell => (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length}>
                  <span className="_tblText">{emptyText}</span>
                </td>
              </tr>
            )}
          </tbody>
        </table> */}
      </div>
    </div>
  );
};

export default CommonReactTable;
